import { ChipModeEnum } from '../../pages/main/shared/components/chip/chip-mode.enum';

export enum PentestStatus {
  ActionNeeded = 0,
  ActionNeededPaused = 1,
  Done = 2,
  Ended = 3,
  Error = 4,
  Paused = 5,
  Pausing = 6,
  Preparing = 7,
  PreparingStartPaused = 8,
  Processing = 9,
  Resuming = 10,
  Running = 11,
  Scheduled = 12,
  Unknown = 13,
  InstallationNeeded = 14,
}

export namespace PentestStatus {
  export function mapFromApiValue(status: string): PentestStatus {
    const statuses: Record<string, PentestStatus> = {
      ['ACTION_NEEDED']: PentestStatus.ActionNeeded,
      ['ACTION_NEEDED_PAUSED']: PentestStatus.ActionNeededPaused,
      ['DONE']: PentestStatus.Done,
      ['ENDED']: PentestStatus.Ended,
      ['ERROR']: PentestStatus.Error,
      ['PAUSED']: PentestStatus.Paused,
      ['PAUSING']: PentestStatus.Pausing,
      ['PREPARING']: PentestStatus.Preparing,
      ['PREPARING_START_PAUSED']: PentestStatus.PreparingStartPaused,
      ['PROCESSING']: PentestStatus.Processing,
      ['RESUMING']: PentestStatus.Resuming,
      ['RUNNING']: PentestStatus.Running,
      ['SCHEDULED']: PentestStatus.Scheduled,
      ['UNKNOWN']: PentestStatus.Unknown,
      ['INSTALLATION_NEEDED']: PentestStatus.InstallationNeeded,
    };
    return statuses[status];
  }

  export function name(status: PentestStatus): string {
    const names: Record<PentestStatus, string> = {
      [PentestStatus.ActionNeeded]: 'dashboard.pentestStatuses.actionNeeded',
      [PentestStatus.ActionNeededPaused]: 'dashboard.pentestStatuses.actionNeededPaused',
      [PentestStatus.Done]: 'dashboard.pentestStatuses.done',
      [PentestStatus.Ended]: 'dashboard.pentestStatuses.done',
      [PentestStatus.Error]: 'dashboard.pentestStatuses.error',
      [PentestStatus.Paused]: 'dashboard.pentestStatuses.paused',
      [PentestStatus.Pausing]: 'dashboard.pentestStatuses.pausing',
      [PentestStatus.Preparing]: 'dashboard.pentestStatuses.preparing',
      [PentestStatus.PreparingStartPaused]: 'dashboard.pentestStatuses.preparingStartPaused',
      [PentestStatus.Processing]: 'dashboard.pentestStatuses.processing',
      [PentestStatus.Resuming]: 'dashboard.pentestStatuses.resuming',
      [PentestStatus.Running]: 'dashboard.pentestStatuses.running',
      [PentestStatus.Scheduled]: 'dashboard.pentestStatuses.scheduled',
      [PentestStatus.Unknown]: 'dashboard.pentestStatuses.unknown',
      [PentestStatus.InstallationNeeded]: 'dashboard.pentestStatuses.installationNeeded',
    };

    return names[status] || 'dashboard.pentestStatuses.unknown';
  }

  export function mode(status: PentestStatus): ChipModeEnum {
    const names: Record<PentestStatus, ChipModeEnum> = {
      [PentestStatus.ActionNeeded]: ChipModeEnum.warning,
      [PentestStatus.ActionNeededPaused]: ChipModeEnum.warning,
      [PentestStatus.Done]: ChipModeEnum.success,
      [PentestStatus.Ended]: ChipModeEnum.success,
      [PentestStatus.Error]: ChipModeEnum.danger,
      [PentestStatus.Paused]: ChipModeEnum.running,
      [PentestStatus.Pausing]: ChipModeEnum.warning,
      [PentestStatus.Preparing]: ChipModeEnum.running,
      [PentestStatus.PreparingStartPaused]: ChipModeEnum.warning,
      [PentestStatus.Processing]: ChipModeEnum.running,
      [PentestStatus.Resuming]: ChipModeEnum.running,
      [PentestStatus.Running]: ChipModeEnum.running,
      [PentestStatus.Scheduled]: ChipModeEnum.running,
      [PentestStatus.Unknown]: ChipModeEnum.warning,
      [PentestStatus.InstallationNeeded]: ChipModeEnum.warning,
    };

    return names[status] || ChipModeEnum.warning;
  }
}
